import { useMemo } from 'react';
import { getJokerFieldType } from '../utils/helper';
import { JokerFieldTypes } from '../config/joker';
import dayjs from 'dayjs';

/**
 * Hook for generating joker columns.
 * @param {Array} jokerFields - Joker field definitions
 * @returns {Array} DataGrid column definitions
 */
export default function useGenerateJokerReportCols(jokerFields) {
  return useMemo(() => {
    return jokerFields.map((f) => {
      const fieldType = getJokerFieldType(f);
      let columnType = 'string';
      if (fieldType === JokerFieldTypes.NUMBER) columnType = 'number';
      else if (fieldType === JokerFieldTypes.SELECT) columnType = 'singleSelect';
      else if (fieldType === JokerFieldTypes.DATE) columnType = 'date';

      return {
        field: f.field,
        headerName: f.name,
        type: columnType,
        editable: false,
        sortable: false,
        ...(fieldType === JokerFieldTypes.DATE && {
          valueGetter: (_data, row) => {
            return new Date(row[f.field]);
          },
        }),
        renderCell: (data) => {
          if (fieldType === JokerFieldTypes.SELECT && Array.isArray(f.valuesToForm)) {
            const findedItem = f.valuesToForm.find((u) => u.value === data.row?.[f.field]);
            return findedItem?.label ?? '';
          }

          if (fieldType === JokerFieldTypes.DATE) {
            const dateValue = data.row?.[f.field];
            return dateValue ? dayjs(dateValue).format('YYYY-MM-DD') : '';
          }

          return data.row?.[f.field] ?? '';
        },
        ...(fieldType === JokerFieldTypes.SELECT && {
          valueOptions: f.valuesToForm
            ? f.valuesToForm.map((v) => ({ value: v.value, label: v.label ?? v.value }))
            : [],
        }),
      };
    });
  }, [jokerFields]);
}
